import { useState } from "react";
import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { useInsideAppShell } from "../design/components/AppShell";
import { Button } from "../design/components/Button";
import { Card } from "../design/components/Card";
import { PublicShell } from "../design/components/PublicShell";
import { useT } from "../i18n/locale";
import { SignOutError } from "../session/switch-tab";
import "./auth.css";

/**
 * Pagina d'errore del router (piano M1b D17): un server che non risponde, un errore di rete o un'uscita non
 * riuscita. Non tocca l'azienda della scheda; «Riprova» rilegge la pagina da capo, guardie comprese. Dentro
 * il guscio ha già intorno la rail (lo dice il guscio stesso); fuori prende la cornice delle pagine pubbliche.
 */
export function ErrorPage({ error }: ErrorComponentProps) {
  const t = useT();
  const router = useRouter();
  const [retrying, setRetrying] = useState(false);
  const insideShell = useInsideAppShell();

  async function retry() {
    setRetrying(true);
    try {
      await router.invalidate();
    } finally {
      setRetrying(false);
    }
  }

  const content = (
    <Card className="g-stack">
      <p className="g-auth__message" data-tone="error" role="alert">
        {error instanceof SignOutError ? t("errorPage.signOut") : t("errorPage.message")}
      </p>
      <div className="g-auth__actions">
        <Button onClick={() => void retry()} disabled={retrying}>{t("common.retry")}</Button>
      </div>
    </Card>
  );
  return insideShell ? content : <PublicShell>{content}</PublicShell>;
}
